// extracted by mini-css-extract-plugin
module.exports = {"section":"ShareModal_section__2Edg9","content":"ShareModal_content__2qllH","top":"ShareModal_top__1Wjhi","arrow":"ShareModal_arrow__2_Z5p","bottom":"ShareModal_bottom__3Kw0u"};